import * as React from 'react'
import ReactPaginate from 'react-paginate'

import styles from './AppPagination.module.scss'

interface Props {
  onPageChange?(selected: number): void
  count: number
  initialPage?: number
  forcePage?: number
}

export const AppPagination: React.FC<Props> = ({
  onPageChange,
  count,
  initialPage,
  forcePage,
}) => {
  return (
    <div className={styles.wrapper}>
      <ReactPaginate
        previousClassName={styles.prev}
        nextClassName={styles.next}
        activeClassName={styles.selected}
        className={styles.container}
        breakLabel="..."
        nextLabel=">"
        initialPage={initialPage}
        forcePage={forcePage}
        onPageChange={item => onPageChange?.(item.selected + 1)}
        pageRangeDisplayed={3}
        pageCount={Math.ceil(count)}
        previousLabel="<"
        renderOnZeroPageCount={() => null}
      />
    </div>
  )
}
